<template>
    <lottie ref="lottie" :style="style" :options="options" v-on:animCreated="handleAnimation"></lottie>
</template>

<script>
    import Lottie from 'vue-lottie'
    export default {
        name: "Animation",
        components: {Lottie},
        props: {
            src: {
                type: Object,
            },
            speed: {
                type: Number,
                default: 1,
            },
            width: {
                type: String,
            },
            height: {
                type: String,
            },
            loop: {
                type: Boolean,
                default: false,
            },
            autoplay: {
                type: Boolean,
                default: true,
            },
            margin: {
                type: String,
                default: '0',
            }
        },
        data() {
            return {
                anim: null
            };
        },
        computed: {
            options()
            {
                return {
                    animationData: this.src,
                    loop: this.loop,
                    autoplay: this.autoplay,
                    preserveAspectRatio: 'none',
                };
            },
            style()
            {
                return {
                    width: this.width,
                    height: this.height,
                    margin: this.margin,
                }
            }
        },
        methods: {
            handleAnimation(anim) {
                this.anim = anim;
                this.anim.setSpeed(this.speed);
            }
        },
    }
</script>

<style scoped>

</style>